import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Tooltip } from '../../../../common/tooltip'
import classes from './index.module.scss'
import { selectById, uncheckItem } from './store/slice'

const Action = ({ rowId, deleteTemplate, openTemplate, page, pageSize }) => {
  const dispatch = useDispatch()

  const byId = useSelector(selectById)

  const [isShowPopupDelete, setIsShowPopupDelete] = useState(false)

  const template = byId[rowId]

  const open = () => openTemplate(template)

  const deleteAction = () => {
    deleteTemplate({
      param: { ids: [template.id] },
      paramGet: { Page: page, PageSize: pageSize },
    })
    dispatch(uncheckItem(template.id))
    closePopupDelete()
  }

  const openPopupDelete = () => setIsShowPopupDelete(true)

  const closePopupDelete = () => setIsShowPopupDelete(false)

  return (
    <div className="dFlex alignItemsCenter">
      <Tooltip isI18n tooltipContent="preferenceSetting.OPEN">
        <Icon
          style={{ fontSize: 15, color: '#0553A5' }}
          className="icon-open-new"
          onClick={open}
        />
      </Tooltip>
      <div className={classes.ml12}>
        <Tooltip isI18n tooltipContent="preferenceSetting.REMOVE">
          <Icon
            style={{
              fontSize: 15,
              color: '#9C9C9C',
            }}
            className="icon-trash-fill"
            onClick={openPopupDelete}
          />
        </Tooltip>
      </div>
      <PopupAction
        isShow={isShowPopupDelete}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={closePopupDelete}
        btnCancel={{
          label: 'common.NO',
          event: closePopupDelete,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: deleteAction,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.DELETE_CONFIRM_1" />
        <span className="fw600">{template.templateName}</span>
        <Translate value="preferenceSetting.DELETE_CONFIRM_2" />
      </PopupAction>
    </div>
  )
}

Action.propTypes = {
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isActive: PropTypes.bool,
}

export default Action
